import { ApiResponseSimple, ErrorCallbackFunction, getObject,getJson } from "../ChoiceApi";
import {IDocumentImageBase64Response,LogoSize} from '../../lib/Models/CompanyModel';

export async function isFeatureEnabled(groupName: string, errorCallback?: ErrorCallbackFunction): Promise<boolean|undefined>
{
    return await getObject<boolean>(`api/Company/Feature/Enabled/${groupName}`, errorCallback);
}
export async function getCompanyLogo(imageSize?: LogoSize) : Promise<IDocumentImageBase64Response> {
    if (!imageSize) {
        imageSize = LogoSize.Small;
    }
    var logoInformation = await getJson(`api/Company/GetCompanyLogo/${imageSize}`);
    if (logoInformation) {
        return logoInformation as IDocumentImageBase64Response;
    }
    return {imageBase64: "", mimeType: "", imageName: ""};
}